import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@mui/styles'
import Tooltip from '@mui/material/Tooltip'

const htmlReplacements = [
  // enums
  { exp: /<li>([^<]*)<\/li+>/g, value: '$1, ' },
  // encosing html
  { exp: /<[^>]+>([^<]*)<\/[^>]+>/g, value: '$1, ' },
  // everything else and cleanup
  { exp: /<[^>]+>/g, value: '' },
  { exp: /&nbsp;/g, value: ' ' },
  { exp: /,\W+,/g, value: ',' },
  // trimming
  { exp: /^[\W,]+|[\W,]+$/g, value: '' },
]

const HtmlCell = (props) => {
  const { value } = props
  const classes = useStyles()
  const plainText = htmlReplacements.reduce((result, replacement) => {
    let newResult = result
    while (replacement.exp.test(newResult)) {
      newResult = newResult.replace(replacement.exp, replacement.value)
    }
    return newResult
  }, value || '')
  return (
    <div className={classes.htmlCellWrapper}>
      {plainText.trim()}
    </div>
  )
}

const useStyles = makeStyles((theme) => ({
  htmlCellWrapper: {
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    alignItems: 'center',
    height: 50,
  },
  tooltip: {
    fontSize: 11,
  },
}))

HtmlCell.propTypes = {
  data: PropTypes.object,
}

export default HtmlCell
